import { render } from "./enFooter.vue?vue&type=template&id=622c5311&scoped=true"
const script = {}

import "./enFooter.vue?vue&type=style&index=0&id=622c5311&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622c5311"]])

export default __exports__